import ToastTitle from '#/components/common/toast/Title';
import Success from '#/components/common/toast/Success';
import Error from '#/components/common/toast/Error';
import Info from '#/components/common/toast/Info';
import Action from '#/components/common/toast/Action';

import DepositIcon from '#/assets/DepositIcon';

import * as PortfolioNavigationFn from '#/features/navigation/portfolio-functions';

import { Link } from './atoms';

interface DepositAmountProps {
  readonly amount: string;
}

/**
 * Toast to display when transaction to deposit
 * to Paraclear succeeds.
 */
export function DepositSuccessful(props: DepositAmountProps) {
  return (
    <Success>
      <ToastTitle>Deposit to Paraclear successful</ToastTitle>
      {props.amount}
    </Success>
  );
}

/**
 * Toast to display when transaction to deposit
 * to Paraclear fails.
 */
export function DepositFailed(props: DepositAmountProps) {
  return (
    <Error>
      <ToastTitle>Deposit to Paraclear failed</ToastTitle>
      {props.amount}
    </Error>
  );
}

/**
 * Toast to display whenever the UI detects
 * an unknown error in the deposit process.
 */
export function DepositUnexpectedError() {
  return (
    <Error>
      <ToastTitle>Deposit to Paraclear failed</ToastTitle>
      Unexpected error. Try again.
    </Error>
  );
}

/**
 * Toast to display when transaction to deposit
 * to Ethereum bridge was successfully sent.
 */
export function DepositRequestSent(props: DepositAmountProps) {
  const icon = <DepositIcon size={19} />;

  return (
    <Info icon={icon}>
      <ToastTitle>Deposit to bridge initiated</ToastTitle>
      {props.amount}
    </Info>
  );
}

/**
 * Toast to display deposit arrived on StarkNet.
 */
export function DepositRequestReady(props: DepositAmountProps) {
  const icon = <DepositIcon size={19} />;
  return (
    <Action icon={icon}>
      <ToastTitle>Deposit to Paraclear available</ToastTitle>
      {props.amount}
      <Link to={PortfolioNavigationFn.linkToActiveTab('deposit-withdraw')}>
        Go to Deposits
      </Link>
    </Action>
  );
}

/**
 * Toast to display when transaction to deposit
 * to Paraclear will be sent.
 */
export function DepositToParaclearInProgress(props: DepositAmountProps) {
  const icon = <DepositIcon size={19} />;

  return (
    <Info icon={icon}>
      <ToastTitle>Deposit to Paraclear in progress</ToastTitle>
      {props.amount}
    </Info>
  );
}
